var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 29,
    viewBox: "0 0 48 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.36597 27.3234C8.8282 27.3234 10.0136 26.1509 10.0136 24.7044C10.0136 23.258 8.8282 22.0854 7.36597 22.0854C5.90375 22.0854 4.71838 23.258 4.71838 24.7044C4.71838 26.1509 5.90375 27.3234 7.36597 27.3234Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.484 27.3234C22.9462 27.3234 24.1315 26.1509 24.1315 24.7044C24.1315 23.258 22.9462 22.0854 21.484 22.0854C20.0217 22.0854 18.8364 23.258 18.8364 24.7044C18.8364 26.1509 20.0217 27.3234 21.484 27.3234Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0135 24.7046H18.8379",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1315 24.7044H26.7791C27.2667 24.7044 27.6622 24.3132 27.6622 23.8309V19.4664C27.6622 18.9841 27.2667 18.5929 26.7791 18.5929H23.25L18.2135 13.6109C18.0485 13.4476 17.824 13.355 17.5906 13.355H5.19111C4.89676 13.355 4.62175 13.5006 4.45823 13.7432L1.19073 18.5915V23.828C1.19073 24.3103 1.58616 24.7014 2.07376 24.7014H4.72135",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 18.5947H1.18927",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52448 12.0393V6.02197H41.2911V25.968",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8107 1.67627H4.00482V6.02163H46.8107V1.67627Z",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6364 13.0418V9.92139H36.6173V25.9676H30.0838",
    stroke: "#FF7403",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIcon2);
export default __webpack_public_path__ + "static/media/why_icon2.d8bf7171e5ad583c41135992c5a0952c.svg";
export { ForwardRef as ReactComponent };